export function getNativeEvent(event) {
  return event.nativeEvent || event;
}